import AccountsConfig from "../Config"
export default class Config {
    //Base & API
    static get BASE_URL() {return AccountsConfig.BASE_API_URL};
    static get BASE_API_URL() {return '/api/1.0/'};
    static get AUTH_API_URL() {return this.BASE_API_URL+ 'auth/token/'};
    static get AUTH_REFRESH_API_URL() {return this.BASE_API_URL+ 'auth/token/refresh/'};

    //User
    static get USER_API_URL() {return this.BASE_API_URL+"user/"};
    static get FORGOTPASS_API_URL() {return this.USER_API_URL + "forgotPassword/"};
    static get RESETPASS_API_URL() {return this.USER_API_URL + "resetPassword/"};
    static get VALIDATE_ACCOUNT_API_URL() {return this.USER_API_URL + "validate/"};

    //Config
    static get API_URL_LANGUAGE () {return this.BASE_API_URL+"config_languages/"};
    static get API_URL_CONFIG () {return this.BASE_API_URL+"config/"};
    static get API_URL_CONFIG_FRONT () {return this.API_URL_CONFIG+"getConfigFront/"};
    static get API_URL_CONFIG_IDENTITY_TEXT () {return this.BASE_API_URL+"config_identityText/"};
    static get API_URL_CONFIG_IDENTITY_IMAGE () {return this.BASE_API_URL+"config_identityImage/"};
    // static get API_URL_CONFIG_MOBILEAPP () {return this.BASE_API_URL+"config_mobileApp/"};
    static get API_URL_CONFIG_WEBSITE () {return this.BASE_API_URL+"config_website/"};
    static get API_URL_CONFIG_MOBILEAPP_TEXT () {return this.BASE_API_URL+"config_mapp_text/"};
    static get API_URL_CONFIG_MOBILEAPP_IMAGE () {return this.BASE_API_URL+"config_mapp_image/"};

    static get API_URL_PRODUCT () {return this.BASE_API_URL+"product/"};
    static get API_URL_PRODUCT_CATEGORY () {return this.BASE_API_URL+"productCategory/"};
    static get API_URL_PRODUCT_CATEGORY_WITH_SUBCATEGORIES () {return this.API_URL_PRODUCT_CATEGORY+"withSubCategories/"};
    static get API_URL_LOCATIONS () {return this.BASE_API_URL+"location/"};
    static get API_URL_ORDERS () {return this.BASE_API_URL+"orders/"};

    static get API_URL_COUNTRY () {return this.BASE_API_URL+"country/"};
    static get API_URL_COUNTY () {return this.BASE_API_URL+"county/"};
    static get API_URL_CITY () {return this.BASE_API_URL+"city/"};
}
